/**
 * Which vMix output a DeckLink port shows
 * (docs/signal-flow-tracing-plan.md, "Model changes").
 *
 * vMix doesn't report which device an output uses, so the config says it
 * per capture card port: "DL7 is vMix Output 2". Signal tracing follows
 * such a port into vMix. Set by hand until it can be read from vMix.
 *
 * Not bridge-owned: it stays editable while the config is active, and
 * bridge pushes keep the cloud's copy (`mergeCloudOwnedConfigData`).
 */
export const VMIX_OUTPUTS = [
    "output1",
    "output2",
    "output3",
    "output4",
    "external1",
    "external2",
];
export const VMIX_OUTPUT_LABELS = {
    output1: "Output 1",
    output2: "Output 2",
    output3: "Output 3",
    output4: "Output 4",
    external1: "External 1",
    external2: "External 2",
};
export function isVmixOutput(value) {
    return VMIX_OUTPUTS.includes(value);
}
/** The setup of config data, without entries that are not vMix outputs. */
export function vmixOutputsOf(data) {
    const setup = {};
    for (const [portID, output] of Object.entries(data?.vmix_outputs ?? {})) {
        if (isVmixOutput(output))
            setup[portID] = output;
    }
    return setup;
}
/** Set or clear (null) the vMix output of a port. */
export function setVmixOutput(setup, portID, output) {
    const next = { ...setup };
    if (output)
        next[portID] = output;
    else
        delete next[portID];
    return next;
}
